// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ChevronDown = createIcon(
  <path
    clipRule="evenodd"
    d="M6.76677 10.9603C7.11824 10.6088 7.68809 10.6088 8.03956 10.9603L11.9996 14.9203L15.9596 10.9603C16.3111 10.6088 16.881 10.6088 17.2324 10.9603C17.5839 11.3118 17.5839 11.8816 17.2324 12.2331L12.636 16.8295C12.2845 17.181 11.7147 17.181 11.3632 16.8295L6.76677 12.2331C6.4153 11.8816 6.4153 11.3118 6.76677 10.9603Z"
    fillRule="evenodd"
  />,
);
